<template>
  <div class="app-container">
    <el-card>
      <el-divider
        direction="horizontal"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff', padding: '0 5px' }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          基本信息
        </h3>
      </el-divider>
      <el-form
        ref="formRef"
        class="mt25"
        :model="formData"
        inline
        label-position="top"
        :rules="formRules"
      >
        <el-form-item prop="name" label="入库单名称">
          <el-input v-model="formData.name" style="width: 240px" />
        </el-form-item>
        <el-form-item label="入库仓库" prop="inWarehouse">
          <el-select
            v-model="formData.inWarehouse"
            filterable
            clearable
            placeholder="请选择入库仓库"
            style="width: 240px"
          >
            <el-option
              v-for="subItem in warehouseList"
              :key="subItem.warehouseId"
              :label="subItem.warehouseName"
              :value="subItem.warehouseId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.remarks" style="width: 240px" />
        </el-form-item>
      </el-form>
      <el-divider
        direction="horizontal"
        :style="{
          color: '#1989fa',
          borderColor: '#d0e6ff',
          marginTop: '25px',
          padding: '0 5px',
        }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          产品信息
        </h3>
      </el-divider>
      <SelectProductTable
        class="mt25"
        ref="selectProductTableRef"
        :data="selectProductTableData"
        :warehouseId="formData.inWarehouse"
        :disabledDelAndAdd="disabledDelAndAdd"
      />
      <el-divider
        direction="horizontal"
        border-style="dashed"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff' }"
      >
      </el-divider>
      <el-row :gutter="8" class="mt5">
        <el-col :span="1.5">
          <el-button
            type="primary"
            :disabled="saveIngFlag"
            @click="handleSubmit"
            >提交</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleSaveDraft"
            >保存草稿</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleImportDraft"
            >导入草稿</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleReset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <ImportDraft
      v-model="draftDialogOpen"
      :searchData="{ status: '1', type: '0' }"
      :columns="importDraftColumns"
      @success="handleImportDraftSuccess"
    />
    <!-- 错误数据 -->
    <ErrDataDialog :data="errTableData" title="入库失败说明" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import useCacheStore from "@/store/modules/cache";
import SelectProductTable from "@/views/warehouse/components/SelectProductTable";
import ImportDraft from "@/views/warehouse/components/ImportDraft";
import { inputWarehouse } from "@/api/warehouse/outInWarehouse";
import { getCustomTableCols } from "@/tableColumn";
import { isNull } from "@/utils/fangerUtils";
import { errorMsg } from "@/utils/msgBox";
import ErrDataDialog from "@/views/warehouse/components/errDataDialog";
const cacheStore = useCacheStore();

const { getProductById } = cacheStore;
const warehouseList = cacheStore.warehouse;
/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "standardInWarehouse",
});

// 表单规则
const formRules = {
  name: {
    required: true,
    trigger: "blur",
    message: "入库单名称为必填项",
  },
  inWarehouse: [
    {
      required: true,
      trigger: "blur",
      message: "入库仓库为必填项",
    },
  ],
  workContactNo: [
    {
      required: true,
      trigger: "blur",
      message: "工作联系函编号为必填项",
    },
  ],
};
const formRef = ref(null);
const selectProductTableRef = ref(null);
const selectProductTableData = ref([]);
const errTableData = ref([]);
const formData = ref({});
// 正在保存中标志，防止鼠标误点多次提交
const saveIngFlag = ref(false);
// 提交
const handleSubmit = () => {
  formRef.value.validate((valid) => {
    // 不合规直接返回
    if (!valid) return;
    if (saveIngFlag.value) {
      return;
    }

    const productData = selectProductTableRef.value.getProductData();
    if (productData === null) return;
    // if (productData.length === 0) {
    //   errorMsg("请选择产品，最少选择一个产品");
    //   return;
    // }
    formData.value.jsonData = JSON.stringify(productData);
    saveIngFlag.value = true;
    inputWarehouse({
      ...formData.value,
      completionStatus: "1",
      type: "0",
    })
      .then((res) => {
        // 充值表单
        formData.value = {};
        formRef.value.resetFields();
        selectProductTableRef.value.clearProductData();
        saveIngFlag.value = false;
      })
      .catch((res) => {
        errTableData.value = res.data;
        saveIngFlag.value = false;
      });
  });
};
// 保存草稿
const handleSaveDraft = () => {
  formRef.value.validate((valid) => {
    // 不合规直接返回
    if (!valid) return;
    if (saveIngFlag.value) {
      return;
    }

    const productData = selectProductTableRef.value.getProductData(false);
    if (productData === null) return;
    formData.value.jsonData = JSON.stringify(productData);
    saveIngFlag.value = true;
    inputWarehouse({
      ...formData.value,
      completionStatus: "0",
      type: "0",
    })
      .then((res) => {
        // 重置表单
        formData.value = {};
        formRef.value.resetFields();
        selectProductTableRef.value.clearProductData();
        saveIngFlag.value = false;
      })
      .catch((res) => {
        errTableData.value = res.data;
        saveIngFlag.value = false;
      });
  });
};

// 重置
const handleReset = () => {
  disabledDelAndAdd.value = false;
  formData.value = {};
  formRef.value.resetFields();
  selectProductTableRef.value.clearProductData();
};

const draftDialogOpen = ref(false);
// 导入草稿
const handleImportDraft = () => {
  draftDialogOpen.value = true;
};
const disabledDelAndAdd = ref(false);
const handleImportDraftSuccess = (data) => {
  formData.value = data;
  const draftList = JSON.parse(data.draft);
  const reData = [];
  if (
    !isNull(draftList) &&
    draftList instanceof Array &&
    draftList.length > 0
  ) {
    draftList.forEach((item) => {
      item.oriIncompleteNumber = item.incompleteNum;
      reData.push({
        ...getProductById(item.productId),
        ...item,
      });
    });
  }
  disabledDelAndAdd.value = true;
  selectProductTableData.value = reData;
};

const importDraftColumns = getCustomTableCols([
  "name",
  "contractNo",
  "batchNo",
  "inWarehouse",
  "operateTime",
  "operatorName",
]);
</script>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin: 15px 0;
}
</style>
